import { Box, Button, Dialog, DialogActions, Divider, Stack, Typography } from "@mui/material";
import RenderInputField from "components/ReusableComponents/RenderInputField/RenderInputField";
import {
	blendColumn,
	blendTypeDropdowns,
	calculateFabricFinalColumns,
	constructionColumnsObj,
	countColumn,
	countUnitDropdowns,
	fabricCategoriesObj,
	fabricCategoryColumn,
	fabricFinalColumns,
	fabricMasterColumnsObj,
	fabricTypeDropdowns,
	finishDropdowns,
	knitCountColumn,
	waveKnitDropdowns,
	weightColumn,
	weightUnitDropdowns,
	wovencountWarpColumn,
	wovencountweftColumn,
} from "../data";
import { arrType, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";
import { useEffect, useState } from "react";
import { AddRounded, DeleteRounded } from "@mui/icons-material";
import { getColDefaultValue } from "components/PimDashboard/data";
import { GlobalState } from "context/GlobalContext";

const CreateOrUpdateFabricModal = ({ open, setOpen, handleSaveFunction = () => {}, mode = "create", selectedRow, setSelectedRow }) => {
	const { snackBar, setSnackBarOpen, setSnackBar } = GlobalState();
	const handleCloseModal = () => {
		setOpen(false);
		setWarpArr(["0_ "]);
		setWeftArr(["0_ "]);
		setBlendArr(["0_ "]);
		setWeightArr(["0_ "]);
		setKnitCountArr(["0_ "]);
		setErrorObj({});
		setPageData(calculateFabricFinalColumns({ ...defPageData }));
		setSelectedRow();
	};
	const defPageData = {
		...Object.values(fabricMasterColumnsObj)
			.map((col) => ({ [col.key]: getColDefaultValue(col) }))
			.reduce((acc, row) => {
				return { ...acc, ...row };
			}, {}),
		[knitCountColumn.key]: getColDefaultValue(knitCountColumn),
		[wovencountWarpColumn.key]: getColDefaultValue(wovencountWarpColumn),
		[wovencountweftColumn.key]: getColDefaultValue(wovencountweftColumn),
		[fabricCategoryColumn.key]: getColDefaultValue(fabricCategoryColumn),
		[weightColumn.key]: getColDefaultValue(weightColumn),
		[blendColumn.key]: getColDefaultValue(blendColumn),
		[constructionColumnsObj.construction_warp.key]: getColDefaultValue(constructionColumnsObj.construction_warp),
		[constructionColumnsObj.construction_weft.key]: getColDefaultValue(constructionColumnsObj.construction_weft),
	};

	const [pageData, setPageData] = useState(calculateFabricFinalColumns({ ...defPageData }));

	const [knitCountArr, setKnitCountArr] = useState(["0_ "]); // for count fabric types
	// for woven count
	const [warpArr, setWarpArr] = useState(["0_ "]); // for count fabric types
	const [weftArr, setWeftArr] = useState(["0_ "]); // for count fabric types

	const [weightArr, setWeightArr] = useState(["0_ "]); // for count fabric types
	const [blendArr, setBlendArr] = useState(["0_ "]); // for blend fabric types

	const [errorObj, setErrorObj] = useState({});
	const [remainingBlendPercent, setRemainaingBlendPercent] = useState(100);

	useEffect(() => {
		if (mode === "update") {
			setPageData(selectedRow);
			setKnitCountArr(selectedRow?.[knitCountColumn.key]?.split("+") || ["0_ "]);
			setWarpArr(selectedRow?.[wovencountWarpColumn.key]?.split("+") || ["0_ "]);
			setWeftArr(selectedRow?.[wovencountweftColumn.key]?.split("+") || ["0_ "]);
			let blendArrState = selectedRow?.[blendColumn.key]?.split(" ") || ["0_ "];
			setBlendArr(blendArrState);
			setRemainaingBlendPercent(
				blendArrState.reduce((acc, curr, i) => {
					return acc - +curr.split("_")[0];
				}, 100),
			);

			setWeightArr(selectedRow?.[weightColumn.key]?.split("+") || ["0_ "]);
		}
	}, [selectedRow]);

	const generateKeysforSplitInputFields = (type, index) => {
		if (type === knitCountColumn.key)
			return {
				noKey: `count_${index}`,
				strKey: `count_unit_${index}`,
			};
		if (type === wovencountWarpColumn.key)
			return {
				noKey: `warp_${index}`,
				strKey: `warp_unit_${index}`,
			};
		if (type === wovencountweftColumn.key)
			return {
				noKey: `weft_${index}`,
				strKey: `weft_unit_${index}`,
			};
		if (type === blendColumn.key)
			return {
				noKey: `blend__${index}`,
				strKey: `material_${index}`,
			};
		if (type === weightColumn.key)
			return {
				noKey: `weight_${index}`,
				strKey: `weight_unit_${index}`,
			};
	};

	const handleKnitCountChange = (value, index) => {
		const updatedCountArr = [...knitCountArr];
		updatedCountArr[index] = value;
		setPageData((prev) => {
			let obj = { ...prev, [knitCountColumn.key]: updatedCountArr.join("+") };
			return calculateFabricFinalColumns(obj);
		});
		setKnitCountArr(updatedCountArr);
	};
	const handleWeightChange = (value, index) => {
		const updatedArr = [...weightArr];
		updatedArr[index] = value;
		setPageData((prev) => {
			let obj = { ...prev, [weightColumn.key]: updatedArr.join("+") };
			return calculateFabricFinalColumns(obj);
		});
		setWeightArr(updatedArr);
	};
	const handleBlendChange = (value, index) => {
		const updatedArr = [...blendArr];
		updatedArr[index] = value;
		setRemainaingBlendPercent(
			updatedArr.reduce((acc, curr, i) => {
				// if (i === updatedArr.length - 1) return acc;
				return acc - +curr.split("_")[0];
			}, 100),
		);
		setPageData((prev) => {
			let obj = { ...prev, [blendColumn.key]: updatedArr.join(" ") };
			return calculateFabricFinalColumns(obj);
		});
		setBlendArr(updatedArr);
	};
	const handleWovenCountChange = (value, index, wovenType = "_" || "warp" || "weft") => {
		if (wovenType === "warp") {
			const updatedArr = [...warpArr];
			updatedArr[index] = value;
			setPageData((prev) => {
				let obj = { ...prev, [wovencountWarpColumn.key]: updatedArr.join("+") };
				return calculateFabricFinalColumns(obj);
			});
			setWarpArr(updatedArr);
		}
		if (wovenType === "weft") {
			const updatedArr = [...weftArr];
			updatedArr[index] = value;
			setPageData((prev) => {
				let obj = { ...prev, [wovencountweftColumn.key]: updatedArr.join("+") };
				return calculateFabricFinalColumns(obj);
			});
			setWeftArr(updatedArr);
		}
	};
	const handleKnitAddCount = () => {
		setKnitCountArr([...knitCountArr, "0_ "]);
	};
	const handleKnitDeleteCount = () => {
		if (knitCountArr.length <= 1) return;
		let arr = [...knitCountArr];
		arr.pop();
		setKnitCountArr(arr);
	};

	const handleAddBlend = () => {
		setBlendArr([...blendArr, "0_ "]);
	};
	const handleDeleteBlend = () => {
		if (blendArr.length <= 1) return;
		let arr = [...blendArr];
		arr.pop();
		setBlendArr(arr);
	};
	const handleAddWovenCount = (wovenType) => {
		if (wovenType === "warp")
			if (warpArr.length >= 4) return;
			else setWarpArr([...warpArr, "0_ "]);

		if (wovenType === "weft")
			if (weftArr.length >= 4) return;
			else setWeftArr([...weftArr, "0_ "]);
	};
	const handleDeleteWovenCount = (wovenType) => {
		if (wovenType === "warp") {
			if (warpArr.length <= 1) return;
			let arr = [...warpArr];
			arr.pop();
			setWarpArr(arr);
		}
		if (wovenType === "weft") {
			if (weftArr.length <= 1) return;
			let arr = [...weftArr];
			arr.pop();
			setWeftArr(arr);
		}
	};
	const handleSaveClick = () => {
		let errObj = {};
		const staticColumns = [fabricCategoryColumn, ...Object.values(fabricMasterColumnsObj)];

		staticColumns.forEach((col) => {
			if (col.constraints.NOTNULL) {
				if (!pageData[col.key]) {
					errObj = { ...errObj, [col.key]: `${col.name} is required` };
				}
			}
		});

		blendArr.forEach((row, i) => {
			const { noKey, strKey } = generateKeysforSplitInputFields(blendColumn.key, i);
			if (!row.split("_")[0] || row.split("_")[0] == "0") {
				errObj = { ...errObj, [noKey]: `Please fill the field` };
			}
			if (!row.split("_")[1] || row.split("_")[1] === " ") {
				errObj = { ...errObj, [strKey]: `Please fill the field` };
			}
		});
		weightArr.forEach((row, i) => {
			const { noKey, strKey } = generateKeysforSplitInputFields(weightColumn.key, i);
			if (!row.split("_")[0] || row.split("_")[0] == "0") {
				errObj = { ...errObj, [noKey]: `Please fill the field` };
			}
			if (!row.split("_")[1] || row.split("_")[1] === " ") {
				errObj = { ...errObj, [strKey]: `Please fill the field` };
			}
		});
		if (pageData?.[fabricCategoryColumn.key] === fabricCategoriesObj.KNIT.key)
			knitCountArr.forEach((row, i) => {
				const { noKey, strKey } = generateKeysforSplitInputFields(knitCountColumn.key, i);
				if (!row.split("_")[0] || row.split("_")[0] == "0") {
					errObj = { ...errObj, [noKey]: `Please fill the field` };
				}
				if (!row.split("_")[1] || row.split("_")[1] === " ") {
					errObj = { ...errObj, [strKey]: `Please fill the field` };
				}
			});
		if (pageData?.[fabricCategoryColumn.key] === fabricCategoriesObj.WOVEN.key) {
			Object.values(constructionColumnsObj).forEach((col) => {
				if (col.constraints.NOTNULL) {
					if (!pageData[col.key] || pageData[col.key] == "0") {
						errObj = { ...errObj, [col.key]: `${col.name} is required` };
					}
				}
			});
			warpArr.forEach((row, i) => {
				const { noKey, strKey } = generateKeysforSplitInputFields(wovencountWarpColumn.key, i);
				if (!row.split("_")[0] || row.split("_")[0] == "0") {
					errObj = { ...errObj, [noKey]: `Please fill the field` };
				}
				if (!row.split("_")[1] || row.split("_")[1] === " ") {
					errObj = { ...errObj, [strKey]: `Please fill the field` };
				}
			});
			weftArr.forEach((row, i) => {
				const { noKey, strKey } = generateKeysforSplitInputFields(wovencountweftColumn.key, i);
				if (!row.split("_")[0] || row.split("_")[0] == "0") {
					errObj = { ...errObj, [noKey]: `Please fill the field` };
				}
				if (!row.split("_")[1] || row.split("_")[1] === " ") {
					errObj = { ...errObj, [strKey]: `Please fill the field` };
				}
			});
			Object.values(constructionColumnsObj).forEach((col) => {
				if (col.constraints.NOTNULL) {
					if (!pageData[col.key] || pageData[col.key] == "0") {
						errObj = { ...errObj, [col.key]: `${col.name} is required` };
					}
				}
			});
		}

		blendArr.forEach((row, i) => {
			const { noKey, strKey } = generateKeysforSplitInputFields(blendColumn.key, i);
			if (!row.split("_")[0] || row.split("_")[0] == "0") {
				errObj = { ...errObj, [noKey]: `Please fill the field` };
			}
			if (!row.split("_")[1] || row.split("_")[1] === " ") {
				errObj = { ...errObj, [strKey]: `Please fill the field` };
			}
		});
		if (Object.keys(errObj).length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				severity: "warning",
				message: `Please fill the required Fields ${Object.keys(errObj).join(", ").split("_").join(" ")}`,
			});
			setErrorObj(errObj);
			return;
		} else setErrorObj({});
		console.log(pageData, "fghjkjhgfdfghj");

		if (remainingBlendPercent !== 0) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				severity: "warning",
				message: `Total Blend Percent should be 100%. Remaining ${remainingBlendPercent}%`,
			});
			return;
		}

		if (typeof handleSaveFunction === "function") handleSaveFunction(pageData);
	};
	return (
		<Dialog fullWidth maxWidth="lg" open={open} onClose={handleCloseModal} scroll="body" keepMounted={false}>
			<Stack
				width="100%"
				p={2}
				boxSizing="border-box"
				spacing={2}
				alignItems="center"
				// justifyContent="space-around"
			>
				<Typography variant="h6">{mode === "create" ? "Create" : "Update"} Fabric</Typography>

				{/* fabric Category */}
				<RenderInputField
					column={{
						...fabricCategoryColumn,
						input_type: mode === "create" ? inputTypes.SELECT.key : inputTypes.AUTO_GENERATE.key,
					}}
					data={pageData}
					setData={(dataObj) => {
						const updatedRow = typeof dataObj === "function" ? dataObj({ ...pageData }) : dataObj;
						return updatedRow;
					}}
					onChangeCallBack={(e, value, updated) => {
						setPageData(calculateFabricFinalColumns(updated));
					}}
					selectOptObjName={selectOptionsKeyName}
					width="100%"
					error={errorObj[fabricCategoryColumn.key]}
				/>
				<Box display="flex" width="100%" columnGap={"2%"} flexWrap="wrap">
					<RenderInputField
						column={fabricFinalColumns.fabric_code}
						data={pageData}
						setData={(dataObj) => {}}
						onChangeCallBack={(e, value, updated) => {
							setPageData(calculateFabricFinalColumns(updated));
						}}
						selectOptObjName={selectOptionsKeyName}
						width="32%"
						error={errorObj[fabricFinalColumns.fabric_code.key]}
					/>
					<RenderInputField
						column={{
							...fabricMasterColumnsObj.type,
							[selectOptionsKeyName]: {
								type: arrType,
								list: pageData?.[fabricCategoryColumn.key]
									? fabricTypeDropdowns.filter(
											(item) => item[fabricCategoryColumn.key] === pageData[fabricCategoryColumn.key],
										)
									: [],
							},
						}}
						data={pageData}
						setData={(dataObj) => {
							const updatedRow = typeof dataObj === "function" ? dataObj({ ...pageData }) : dataObj;
							return updatedRow;
						}}
						onChangeCallBack={(e, value, updated) => {
							setPageData(calculateFabricFinalColumns(updated));
						}}
						selectOptObjName={selectOptionsKeyName}
						width="32%"
						error={errorObj[fabricMasterColumnsObj.type.key]}
					/>
					<RenderInputField
						column={{
							...fabricMasterColumnsObj.weave_knit,
							[selectOptionsKeyName]: {
								type: arrType,
								list: pageData?.[fabricCategoryColumn.key]
									? waveKnitDropdowns.filter(
											(item) => item[fabricCategoryColumn.key] === pageData[fabricCategoryColumn.key],
										)
									: [],
							},
						}}
						data={pageData}
						setData={(dataObj) => {
							const updatedRow = typeof dataObj === "function" ? dataObj({ ...pageData }) : dataObj;
							return updatedRow;
						}}
						onChangeCallBack={(e, value, updated) => {
							setPageData(calculateFabricFinalColumns(updated));
						}}
						selectOptObjName={selectOptionsKeyName}
						width="32%"
						error={errorObj[fabricMasterColumnsObj.weave_knit.key]}
					/>
					<RenderInputField
						column={{
							...fabricMasterColumnsObj.finish,
							[selectOptionsKeyName]: {
								type: arrType,
								list: pageData?.[fabricCategoryColumn.key]
									? finishDropdowns.filter(
											(item) => item[fabricCategoryColumn.key] === pageData[fabricCategoryColumn.key],
										)
									: [],
							},
						}}
						data={pageData}
						setData={(dataObj) => {
							const updatedRow = typeof dataObj === "function" ? dataObj({ ...pageData }) : dataObj;
							return updatedRow;
						}}
						onChangeCallBack={(e, value, updated) => {
							setPageData(calculateFabricFinalColumns(updated));
						}}
						selectOptObjName={selectOptionsKeyName}
						width="32%"
						error={errorObj[fabricMasterColumnsObj.finish.key]}
					/>
					<RenderInputField
						column={fabricMasterColumnsObj.sort_no}
						data={pageData}
						setData={(dataObj) => {
							const updatedRow = typeof dataObj === "function" ? dataObj({ ...pageData }) : dataObj;
							return updatedRow;
						}}
						onChangeCallBack={(e, value, updated) => {
							setPageData(calculateFabricFinalColumns(updated));
						}}
						selectOptObjName={selectOptionsKeyName}
						width="32%"
						error={errorObj[fabricMasterColumnsObj.sort_no.key]}
					/>
				</Box>
				<Divider orientation="horizontal" sx={{ width: "100%" }} />

				{/* count */}
				{pageData[fabricCategoryColumn.key] === fabricCategoriesObj.KNIT.key ? (
					<Box width="100%" display="flex" flexWrap="wrap" rowGap={1} columnGap={1}>
						<Typography variant="subtitle1" sx={{ width: "100%" }}>
							Count <span style={{ color: "red" }}>*</span>
						</Typography>
						{knitCountArr.map((item, index) => {
							const { noKey, strKey } = generateKeysforSplitInputFields(knitCountColumn.key, index);
							return (
								<Box sx={{ mr: index % 2 === 0 ? 0 : 2 }} width="30%" display="flex" columnGap="1%">
									<RenderInputField
										key={index}
										column={{
											...knitCountColumn,
											name: `Count ${index + 1}`,
											key: noKey,
										}}
										data={{ [noKey]: item.split("_")[0], [strKey]: item.split("_")[1] }}
										hideLabel
										setData={(dataObj) => {
											const updatedRow = typeof dataObj === "function" ? dataObj({}) : dataObj;
											return updatedRow;
										}}
										onChangeCallBack={(e, value) => {
											const val = `${Number(value) ?? 0}_${item.split("_")[1]}`;
											handleKnitCountChange(val, index);
										}}
										width="48%"
										selectOptObjName={selectOptionsKeyName}
										error={errorObj[noKey]}
									/>
									<RenderInputField
										key={index}
										column={{
											...knitCountColumn,

											name: `Unit ${index + 1}`,
											key: strKey,
											input_type: inputTypes.SELECT.key,
											[selectOptionsKeyName]: { type: arrType, list: countUnitDropdowns },
										}}
										data={{ [noKey]: item.split("_")[0], [strKey]: item.split("_")[1] }}
										hideLabel
										setData={(dataObj) => {
											const updatedRow = typeof dataObj === "function" ? dataObj({}) : dataObj;
											return updatedRow;
										}}
										onChangeCallBack={(e, value) => {
											const val = `${item.split("_")[0]}_${value ?? " "}`;
											handleKnitCountChange(val, index);
										}}
										width="48%"
										selectOptObjName={selectOptionsKeyName}
										error={errorObj[strKey]}
									/>
								</Box>
							);
						})}
						<Box display="flex" alignItems="center" columnGap={1}>
							<Button
								variant="contained"
								onClick={handleKnitDeleteCount}
								size="small"
								startIcon={<DeleteRounded />}
								disabled={knitCountArr?.length <= 1}>
								Delete
							</Button>
							<Button
								variant="contained"
								onClick={handleKnitAddCount}
								size="small"
								startIcon={<AddRounded />}
								disabled={knitCountArr?.length >= 4}>
								Add
							</Button>
						</Box>
					</Box>
				) : (
					<Stack width="100%" spacing={2}>
						{/* Warp */}
						<Box width="100%" display="flex" flexWrap="wrap" rowGap={1} columnGap={1}>
							<Typography variant="subtitle1" sx={{ width: "100%" }}>
								Count (WARP) <span style={{ color: "red" }}>*</span>
							</Typography>
							{warpArr.map((item, index) => {
								const { noKey, strKey } = generateKeysforSplitInputFields(wovencountWarpColumn.key, index);

								return (
									<Box sx={{ mr: index % 2 === 0 ? 0 : 2 }} width="30%" display="flex" columnGap="1%">
										<RenderInputField
											key={index}
											column={{
												...wovencountWarpColumn,
												name: `Count (WARP) ${index + 1}`,
												key: noKey,
												data_type: datatypes.NUMBER.key,
											}}
											data={{ [noKey]: item.split("_")[0], [strKey]: item.split("_")[1] }}
											hideLabel
											setData={(dataObj) => {
												const updatedRow = typeof dataObj === "function" ? dataObj({}) : dataObj;
												return updatedRow;
											}}
											onChangeCallBack={(e, value) => {
												const val = `${Number(value) ?? 0}_${item.split("_")[1]}`;
												handleWovenCountChange(val, index, "warp");
											}}
											width="48%"
											selectOptObjName={selectOptionsKeyName}
											error={errorObj[noKey]}
										/>
										<RenderInputField
											key={index}
											column={{
												...wovencountWarpColumn,

												name: `Unit (WARP) ${index + 1}`,
												key: strKey,
												input_type: inputTypes.SELECT.key,
												[selectOptionsKeyName]: { type: arrType, list: countUnitDropdowns },
											}}
											data={{ [noKey]: item.split("_")[0], [strKey]: item.split("_")[1] }}
											hideLabel
											setData={(dataObj) => {
												const updatedRow = typeof dataObj === "function" ? dataObj({}) : dataObj;
												return updatedRow;
											}}
											onChangeCallBack={(e, value) => {
												const val = `${item.split("_")[0]}_${value ?? " "}`;
												handleWovenCountChange(val, index, "warp");
											}}
											width="48%"
											selectOptObjName={selectOptionsKeyName}
											error={errorObj[strKey]}
										/>
									</Box>
								);
							})}
							<Box display="flex" alignItems="center" columnGap={1}>
								<Button
									variant="contained"
									onClick={() => handleDeleteWovenCount("warp")}
									size="small"
									startIcon={<DeleteRounded />}
									disabled={warpArr?.length <= 1}>
									Delete
								</Button>
								<Button
									variant="contained"
									onClick={() => handleAddWovenCount("warp")}
									size="small"
									startIcon={<AddRounded />}
									disabled={warpArr?.length >= 4}>
									Add
								</Button>
							</Box>
						</Box>
						{/* weft */}
						<Box width="100%" display="flex" flexWrap="wrap" rowGap={1} columnGap={1}>
							<Typography variant="subtitle1" sx={{ width: "100%" }}>
								Count (WEFT) <span style={{ color: "red" }}>*</span>
							</Typography>
							{weftArr.map((item, index) => {
								const { noKey, strKey } = generateKeysforSplitInputFields(wovencountweftColumn.key, index);
								return (
									<Box sx={{ mr: index % 2 === 0 ? 0 : 2 }} width="30%" display="flex" columnGap="1%">
										<RenderInputField
											key={index}
											column={{
												...wovencountweftColumn,
												name: `Count (WEFT) ${index + 1}`,
												key: noKey,
												data_type: datatypes.NUMBER.key,
											}}
											data={{ [noKey]: item.split("_")[0], [strKey]: item.split("_")[1] }}
											hideLabel
											setData={(dataObj) => {
												const updatedRow = typeof dataObj === "function" ? dataObj({}) : dataObj;
												return updatedRow;
											}}
											onChangeCallBack={(e, value) => {
												const val = `${Number(value) ?? 0}_${item.split("_")[1]}`;
												handleWovenCountChange(val, index, "weft");
											}}
											width="48%"
											selectOptObjName={selectOptionsKeyName}
											error={errorObj[noKey]}
										/>
										<RenderInputField
											key={index}
											column={{
												...wovencountweftColumn,

												name: `Unit (WEFT) ${index + 1}`,
												key: strKey,
												input_type: inputTypes.SELECT.key,
												[selectOptionsKeyName]: { type: arrType, list: countUnitDropdowns },
											}}
											data={{ [noKey]: item.split("_")[0], [strKey]: item.split("_")[1] }}
											hideLabel
											setData={(dataObj) => {
												const updatedRow = typeof dataObj === "function" ? dataObj({}) : dataObj;
												return updatedRow;
											}}
											onChangeCallBack={(e, value) => {
												const val = `${item.split("_")[0]}_${value ?? " "}`;
												handleWovenCountChange(val, index, "weft");
											}}
											width="48%"
											selectOptObjName={selectOptionsKeyName}
											error={errorObj[strKey]}
										/>
									</Box>
								);
							})}
							<Box display="flex" alignItems="center" columnGap={1}>
								<Button
									variant="contained"
									onClick={() => handleDeleteWovenCount("weft")}
									size="small"
									startIcon={<DeleteRounded />}
									disabled={weftArr?.length <= 1}>
									Delete
								</Button>
								<Button
									variant="contained"
									onClick={() => handleAddWovenCount("weft")}
									size="small"
									startIcon={<AddRounded />}
									disabled={weftArr?.length >= 4}>
									Add
								</Button>
							</Box>
						</Box>
					</Stack>
				)}

				<Divider orientation="horizontal" sx={{ width: "100%" }} />

				{/* construction and weight */}
				<Box display="flex" justifyContent="space-between" width="100%">
					{/* Construction */}
					{pageData[fabricCategoryColumn.key] === fabricCategoriesObj.WOVEN.key && (
						<Box width="49%" display="flex" flexWrap="wrap" rowGap={1} columnGap={1}>
							<Typography variant="subtitle1" sx={{ width: "100%" }}>
								Construction <span style={{ color: "red" }}>*</span>
							</Typography>

							<Box width="60%" display="flex" columnGap="1%">
								<RenderInputField
									column={constructionColumnsObj.construction_warp}
									data={pageData}
									// hideLabel
									setData={setPageData}
									width="48%"
									error={errorObj[constructionColumnsObj.construction_warp.key]}
								/>
								<RenderInputField
									column={constructionColumnsObj.construction_weft}
									data={pageData}
									// hideLabel
									setData={setPageData}
									width="48%"
									selectOptObjName={selectOptionsKeyName}
									error={errorObj[constructionColumnsObj.construction_weft.key]}
								/>
							</Box>
						</Box>
					)}

					{/* weight */}
					<Box width="49%" display="flex" flexWrap="wrap" rowGap={1} columnGap={1}>
						<Typography variant="subtitle1" sx={{ width: "100%" }}>
							Weight <span style={{ color: "red" }}>*</span>
						</Typography>
						{weightArr.map((item, index) => {
							const { noKey, strKey } = generateKeysforSplitInputFields(weightColumn.key, index);
							return (
								<Box sx={{ mr: index % 2 === 0 ? 0 : 2 }} width="60%" display="flex" columnGap="1%">
									<RenderInputField
										key={index}
										column={{
											...weightColumn,
											name: `Weight ${index + 1}`,
											key: noKey,
											data_type: datatypes.NUMBER.key,
										}}
										data={{ [noKey]: item.split("_")[0], [strKey]: item.split("_")[1] }}
										hideLabel
										setData={(dataObj) => {
											const updatedRow = typeof dataObj === "function" ? dataObj({}) : dataObj;
											return updatedRow;
										}}
										onChangeCallBack={(e, value) => {
											const val = `${Number(value) ?? 0}_${item.split("_")[1]}`;
											handleWeightChange(val, index);
										}}
										width="48%"
										selectOptObjName={selectOptionsKeyName}
										error={errorObj[noKey]}
									/>
									<RenderInputField
										key={index}
										column={{
											...weightColumn,

											name: `Unit ${index + 1}`,
											key: strKey,
											input_type: inputTypes.SELECT.key,
											[selectOptionsKeyName]: { type: arrType, list: weightUnitDropdowns },
										}}
										data={{ [noKey]: item.split("_")[0], [strKey]: item.split("_")[1] }}
										hideLabel
										setData={(dataObj) => {
											const updatedRow = typeof dataObj === "function" ? dataObj({}) : dataObj;
											return updatedRow;
										}}
										onChangeCallBack={(e, value) => {
											const val = `${item.split("_")[0]}_${value ?? " "}`;
											handleWeightChange(val, index);
										}}
										width="48%"
										selectOptObjName={selectOptionsKeyName}
										error={errorObj[strKey]}
									/>
								</Box>
							);
						})}
					</Box>
				</Box>
				<Divider orientation="horizontal" sx={{ width: "100%" }} />

				{/* Blend */}
				<Box width="100%" display="flex" flexWrap="wrap" rowGap={1} columnGap={1}>
					<Typography variant="subtitle1" sx={{ width: "100%" }}>
						Blend <span style={{ color: "red" }}>*</span>
					</Typography>
					{blendArr &&
						blendArr.map((item, index) => {
							const { noKey, strKey } = generateKeysforSplitInputFields(blendColumn.key, index);
							return (
								<Box sx={{ mr: index % 2 === 0 ? 0 : 2 }} width="30%" display="flex" columnGap="1%">
									<RenderInputField
										key={index}
										column={{
											...blendColumn,
											name: `Blend ${index + 1}`,
											key: noKey,
											data_type: datatypes.NUMBER.key,
										}}
										data={{ [noKey]: item.split("_")[0], [strKey]: item.split("_")[1] }}
										hideLabel
										setData={(dataObj) => {
											const updatedRow = typeof dataObj === "function" ? dataObj({}) : dataObj;
											return updatedRow;
										}}
										onChangeCallBack={(e, value) => {
											const val = `${Number(value) ?? 0}_${item.split("_")[1]}`;
											handleBlendChange(val, index);
										}}
										width="48%"
										selectOptObjName={selectOptionsKeyName}
										error={errorObj[noKey]}
									/>
									<RenderInputField
										key={index}
										column={{
											...blendColumn,
											name: `Material ${index + 1}`,
											key: strKey,
											input_type: inputTypes.SELECT.key,
											[selectOptionsKeyName]: { type: arrType, list: blendTypeDropdowns },
										}}
										data={{ [noKey]: item.split("_")[0], [strKey]: item.split("_")[1] }}
										hideLabel
										setData={(dataObj) => {
											const updatedRow = typeof dataObj === "function" ? dataObj({}) : dataObj;
											return updatedRow;
										}}
										onChangeCallBack={(e, value) => {
											const val = `${item.split("_")[0]}_${value ?? " "}`;
											handleBlendChange(val, index);
										}}
										width="48%"
										selectOptObjName={selectOptionsKeyName}
										error={errorObj[strKey]}
									/>
								</Box>
							);
						})}
					<Box display="flex" alignItems="center" columnGap={1}>
						<Button
							variant="contained"
							onClick={handleDeleteBlend}
							size="small"
							startIcon={<DeleteRounded />}
							disabled={blendArr?.length <= 1}>
							Delete
						</Button>
						<Button
							variant="contained"
							onClick={handleAddBlend}
							size="small"
							startIcon={<AddRounded />}
							disabled={blendArr?.length >= 5}>
							Add
						</Button>
					</Box>
				</Box>
				<Typography width="100%">Remaining Percent: {remainingBlendPercent}%</Typography>
				<Divider orientation="horizontal" sx={{ width: "100%" }} />
				<Stack width="100%" spacing={1}>
					{Object.values(fabricFinalColumns).map((row) => {
						return (
							<Typography variant="body1" key={row.key}>
								{row.name} : <span style={{ fontWeight: 600 }}>{pageData[row.key] ?? "-"}</span>
							</Typography>
						);
					})}
				</Stack>
			</Stack>
			<DialogActions>
				<Button variant="outlined" onClick={handleCloseModal}>
					Cancel
				</Button>
				<Button autoFocus variant="contained" sx={{ mr: 1 }} onClick={handleSaveClick}>
					{mode === "create" ? "Create" : "Save"}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default CreateOrUpdateFabricModal;
